import Layout from "../../hocs/Layout";
import { useState } from "react";
import { connect } from "react-redux";
import { resend_activation } from "../../redux/actions/auth";
import { InfinitySpin } from "react-loader-spinner";
import { setAlert } from "../../redux/actions/alert";
import { Link, useNavigate } from "react-router-dom";

const ResendActivation = ({ resend_activation, loading, setAlert }) => {
  const [formData, setFormData] = useState({
    email: "",
  });
  const navigate = useNavigate();
  const [requestSent, setRequestSent] = useState(false);

  const { email } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();

    const result = await resend_activation(email);

    if (result.status === 204) {
      window.scrollTo(0, 0);
      setRequestSent(true);
      setFormData({ email: "" });
      navigate("/login");
    } else if (result.status === 400) {
      setAlert("Error sending activation email.", "red");
    } else {
      setAlert("Error connecting with the server, please try again later.", "red");
    }
  };

  return (
    <Layout>
    {/* Fondo blanco */}
    <div className="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-white">
      {/* Contenedor central */}
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Resend Activation Link
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Or{" "}
          <Link
            to="/login"
            className="font-medium text-emerald-600 hover:text-emerald-500"
          >
            Sign in
          </Link>
        </p>
      </div>

      {/* Formulario */}
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-10 shadow sm:rounded-lg sm:px-10 border border-gray-200">
          <form onSubmit={onSubmit} className="space-y-6">
            {/* Campo de email */}
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Email Address
              </label>
              <div className="mt-1">
                <input
                  name="email"
                  value={email}
                  onChange={onChange}
                  type="email"
                  placeholder="Enter your email"
                  required
                  className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm"
                />
              </div>
            </div>

            {/* Botón de envío */}
            <div>
              {loading ? (
                <button
                  disabled
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-emerald-600"
                >
                  <InfinitySpin color="#fff" width={20} height={20} />
                </button>
              ) : (
                <button
                  type="submit"
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-emerald-600 hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500"
                >
                  Resend Activation Email
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  </Layout>
  );
};

const mapStateToProps = (state) => ({
  loading: state.Auth.loading,
});

export default connect(mapStateToProps, {
  resend_activation,
  setAlert,
})(ResendActivation);
